var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cookie-container"},[_c('iframe',{staticClass:"cookie-iframe",attrs:{"src":_vm.cookieUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }